import { useEffect, useState } from 'react';
import SearchComponent from '../searchComponent';
import { useSearchParams } from 'react-router-dom';
import { getRooms } from '../../api/room-api';
import { formatTime } from '../../utils/dateTimeUtils';
import { useConfig } from '../../providers/configProvider';
import Overlay from '../overlays/editRoom';
import { useLanguage } from '../../providers/preferenceProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ACL } from '../../acls';

const Rooms = () => {
  const [rooms, setRooms] = useState([]);
  const { isAuthorized } = useConfig();
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayRoom, setOverlayRoom] = useState(null);
  const [createNew, setCreateNew] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const pageSize = 10;
  const { t } = useLanguage();
  
  async function fetchData(refresh = false) {
    let localRooms = [...rooms];
    if (refresh) {
      localRooms = [];
    }
    
    const urlParams = getSearchParams(searchParams, pageSize, refresh, localRooms);
    const response = await getRooms(urlParams);

    if (response.data) setRooms(response.data);
  }

  function getSearchParams(searchParams, pageSize, refresh, users) {
    const urlParams = new URLSearchParams();
    urlParams.append('search', searchParams.get('rooms_search') || '');
    return urlParams;
  }

  async function setSearch(query) {
    searchParams.set('rooms_search', query);
    setSearchParams(searchParams);
    fetchData(true);
  }
    
  useEffect(() => {
    fetchData();
  }, []);

  function closeOverlay() {
    setShowOverlay(false);
    setOverlayRoom(null);
  }

  const handleEditRoom = (room) => {
    setCreateNew(false);
    setOverlayRoom(room);
    setShowOverlay(true);
  };

  const handleAddRoom = () => {
    setCreateNew(true);
    setOverlayRoom(null);
    setShowOverlay(true);
  };

  return (
    <>
      <div className="admin-list-wrapper">
        <div className="flex md:flex-row flex-col gap-2 mb-2 justify-between"> 
          <SearchComponent onSearchChange={setSearch}></SearchComponent>
          <button 
            className="admin-add-button"
            disabled={!isAuthorized(ACL.ROOM)}
            onClick={handleAddRoom}
          >
            {t.add + " " + t.room} <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>
        <div className="admin-list-header mb-4 flex justify-between items-center">
          <h2>{t.amount_of + " " + t.rooms + ": " + rooms.length}</h2>
        </div>
        <div className="admin-list-box">
          {rooms.map((room) => (
            <div className="admin-room-entry" key={room.name}>
              <img src={room.image} loading='lazy' alt={room.name} className="admin-room-image" />
              <div className="admin-room-name">
                <h1>{room.name} ({room.floor})</h1>
                <p>{t.room_type + ": " + room.RoomType.name}</p>
                <p>{t.opening_hours + ": " + formatTime(room.openTime) + "-" + formatTime(room.closeTime)}</p>
                <p>{t.capacity + ": " + room.capacity}</p>
                <p style={{ color: room.active ? 'green' : 'red' }}>{room.active ? t.active : t.inactive}</p>
              </div>
              <button 
                className="admin-edit-button"
                disabled={!isAuthorized(ACL.ROOM)}
                onClick={() => handleEditRoom(room)}
              >
                {t.edit} <FontAwesomeIcon icon={faPenToSquare} />
              </button>
            </div>
          ))}
        </div>
      </div>

      {showOverlay && (
        <Overlay
          isOpen={showOverlay}
          onClose={closeOverlay}
          room={overlayRoom}
          createNew={createNew}
          onRefresh={fetchData}
        />
      )}
    </>
  );
};

export default Rooms;